import { createLogger, Logger } from '@gaming1/g1-logger';

export const logger: Logger = createLogger('g1-twinning');
